export default __webpack_public_path__ + "static/media/003-twitter.6d9e0ab1.svg";